import type { AuditResourceTypesFetchedAction } from '@Application/AuditTrail/Actions/auditResourceTypesFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AuditResourceTypesStore = {
	auditResourceTypes: readonly LabeledValueView[] | null;
};

const initialState: AuditResourceTypesStore = {
	auditResourceTypes: null,
};

type Actions = AuditResourceTypesFetchedAction | UserRevokedAction;

const whenAuditResourceTypesFetched = (
	store: AuditResourceTypesStore,
	action: AuditResourceTypesFetchedAction,
): AuditResourceTypesStore => ({
	...store,
	auditResourceTypes: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): AuditResourceTypesStore => initialState;

export default registerStore<'auditResourceTypesStore', Actions>(
	'auditResourceTypesStore',
	createSliceReducer({
		AUDIT_RESOURCE_TYPES_FETCHED: whenAuditResourceTypesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
